import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Box, Drawer, useTheme, useMediaQuery, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Header from '../components/Header';
import Sidebar from '../pages/Sidebar';
import { useAuth } from '../contexts/AuthContext';
import Footer from '../components/Footer';

const DRAWER_WIDTH = 300;

const PrivateLayout: React.FC = () => {
  const { user, loading } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  const sidebar = <Sidebar />;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* === ДЕСКТОП: ФИКСИРОВАННЫЙ САЙДБАР === */}
      {!isMobile && (
        <Box
          sx={{
            width: DRAWER_WIDTH,
            flexShrink: 0,
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            bgcolor: '#1F2937',
            zIndex: 1200,
            overflowY: 'auto',
            boxShadow: 3,
          }}
        >
          {sidebar}
        </Box>
      )}

      {/* === МОБИЛКА: ВЫЕЗЖАЮЩИЙ ДРАВЕР === */}
      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            '& .MuiDrawer-paper': {
              width: DRAWER_WIDTH,
              bgcolor: '#1F2937',
            },
          }}
        >
          {sidebar}
        </Drawer>
      )}

      {/* === ПРАВАЯ ЧАСТЬ: ХЭДЕР + КОНТЕНТ + ФУТЕР === */}
      <Box
        sx={{
          flexGrow: 1,
          width: { xs: '100%', md: `calc(100% - ${DRAWER_WIDTH}px)` },
          // ОТСТУП ТОЛЬКО НА ДЕСКТОПЕ
          ml: { xs: 0, md: `${DRAWER_WIDTH}px` },
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        {/* ХЭДЕР С БУРГЕРОМ */}
        <Header>
          {isMobile && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Header>

        {/* КОНТЕНТ */}
        <Box
          component="main"
          sx={{
            flex: 1,
            p: 3,
            bgcolor: '#F3F4F6',
            overflowY: 'auto',
          }}
        >
          <Outlet />
        </Box>

        {/* ФУТЕР */}
        <Footer />
      </Box>
    </Box>
  );
};

export default PrivateLayout;